import { blipProductUpdatesUrl } from 'app.constants';
import './ProductUpdates.scss';
export class ProductUpdatesController {
    static $inject = ['$sce'];
    constructor($sce) {
        'ngInject';
        this.blipProductUpdatesUrl = $sce.trustAsResourceUrl(blipProductUpdatesUrl);
    }
}
ProductUpdatesController.$inject = ['$sce'];
